import {
  ApiProjectSettingKey,
  ApiReservedConversion,
  ApiProjectType,
} from "@incendium/api";
import {
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from "@mui/material";
import { formatEnumVal } from "Helpers/enumToText";
import { useSelectedProject } from "Hooks";
import { useMemo } from "react";
import { getRelevantReservedConversions } from "../utils/filterReservedConversions";

interface ReservedConversionSelectorProps {
  value: ApiReservedConversion | undefined;
  onChange: (event: any) => void;
  disabled?: boolean;
  className?: string;
}

export const ReservedConversionSelector = ({
  value,
  onChange,
  disabled = false,
  className,
}: ReservedConversionSelectorProps) => {
  const { projectSettings } = useSelectedProject();

  const groupedConversions = useMemo(() => {
    const projectType = projectSettings[ApiProjectSettingKey.PROJECT_TYPE];
    return getRelevantReservedConversions(projectType as ApiProjectType);
  }, [projectSettings]);

  return (
    <FormControl variant="outlined" className={className}>
      <InputLabel htmlFor="reserved-conversion-select">
        select reserved conversion
      </InputLabel>
      <Select
        value={value || ""}
        onChange={onChange}
        label="select reserved conversion"
        name="reserved"
        disabled={disabled}
        id="reserved-conversion-select"
      >
        {groupedConversions.map((group) => [
          <ListSubheader key={`header-${group.group}`}>
            {group.group}
          </ListSubheader>,
          ...group.conversions.map((conversion) => (
            <MenuItem key={conversion} value={conversion}>
              {formatEnumVal(conversion)}
            </MenuItem>
          )),
        ])}
      </Select>
    </FormControl>
  );
};

